export let tabataSetup = {
  setup: {
    type: "tabata",
    sets: 8,
    work: {
      min: "00",
      sec: 20,
    },
    rest: {
      min: "00",
      sec: 10,
    },
    prepare: {
      min: "00",
      sec: 10,
    },
    cooldown: {
      min: "00",
      sec: 10,
    },
    expanded: {
      name: "",
      description: "",
      prepare: {
        min: "00",
        sec: 10,
      },
      cooldown: {
        min: "00",
        sec: 10,
      },
      rounds: [],
    },
  },
};

export let emomSetup = {
  setup: {
    type: "emom",
    sets: 8,
    work: {
      min: "01",
      sec: "00",
    },
    prepare: {
      min: "00",
      sec: 10,
    },
    cooldown: {
      min: "00",
      sec: 10,
    },
    expanded: {
      name: "",
      description: "",
      prepare: {
        min: "00",
        sec: 10,
      },
      cooldown: {
        min: "00",
        sec: 10,
      },
      rounds: [],
    },
  },
};

export let amrapSetup = {
  setup: {
    type: "amrap",
    work: {
      min: "20",
      sec: "00",
    },
    prepare: {
      min: "00",
      sec: 10,
    },
    cooldown: {
      min: "00",
      sec: 10,
    },
    expanded: {
      name: "",
      description: "",
      prepare: {
        min: "00",
        sec: 10,
      },
      cooldown: {
        min: "00",
        sec: 10,
      },
      rounds: [],
    },
  },
};

export let rftSetup = {
  setup: {
    type: "rft",
    isExpanded: false,
    name: "",
    description: "",
    prepare: {
      min: "00",
      sec: 10,
    },
  },
};
